import { render, staticRenderFns } from "./PaqVistaPrevia.vue?vue&type=template&id=46f6af1d&scoped=true"
import script from "./PaqVistaPrevia.vue?vue&type=script&lang=js"
export * from "./PaqVistaPrevia.vue?vue&type=script&lang=js"
import style0 from "./PaqVistaPrevia.vue?vue&type=style&index=0&id=46f6af1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6af1d",
  null
  
)

export default component.exports